// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as ZakatCalculatorRouteImport } from './app/zakat-calculator'
import { Route as TermsConditionsRouteImport } from './app/terms-conditions'
import { Route as StablecoinRouteImport } from './app/stablecoin'
import { Route as SendMoneyHomeRouteImport } from './app/send-money-home'
import { Route as RewardsRouteImport } from './app/rewards'
import { Route as PrivacyPolicyRouteImport } from './app/privacy-policy'
import { Route as PricingRouteImport } from './app/pricing'
import { Route as PerksRouteImport } from './app/perks'
import { Route as PartnershipsRouteImport } from './app/partnerships'
import { Route as NewsRouteImport } from './app/news'
import { Route as InvestRouteImport } from './app/invest'
import { Route as HelpRouteImport } from './app/help'
import { Route as HealthInsuranceRouteImport } from './app/health-insurance'
import { Route as GetTheAppRouteImport } from './app/get-the-app'
import { Route as CompareRouteImport } from './app/compare'
import { Route as CareersRouteImport } from './app/careers'
import { Route as CardsRouteImport } from './app/cards'
import { Route as BusinessRouteImport } from './app/business'
import { Route as AppStoreRedirectRouteImport } from './app/app-store-redirect'
import { Route as AppRouteImport } from './app/app'
import { Route as AboutRouteImport } from './app/about'
import { Route as PayloadRouteImport } from './app/_payload'
import { Route as SplatRouteImport } from './app/$'
import { Route as IndexRouteImport } from './app/index'
import { Route as ArIndexRouteImport } from './app/ar.index'
import { Route as LocaleIndexRouteImport } from './app/$locale.index'
import { Route as TermsCookieRouteImport } from './app/terms.cookie'
import { Route as TermsSplatRouteImport } from './app/terms.$'
import { Route as SyriaSlugRouteImport } from './app/syria.$slug'
import { Route as ProductsBusinessSuccessRouteImport } from './app/products.business-success'
import { Route as PakistanSlugRouteImport } from './app/pakistan.$slug'
import { Route as NewsSlugRouteImport } from './app/news_.$slug'
import { Route as HelpSlugRouteImport } from './app/help_.$slug'
import { Route as CalculatorPairRouteImport } from './app/calculator.$pair'
import { Route as BusinessWaitlistRouteImport } from './app/business_.waitlist'
import { Route as BangladeshSlugRouteImport } from './app/bangladesh.$slug'
import { Route as ArticleSlugRouteImport } from './app/article.$slug'
import { Route as ArPricingRouteImport } from './app/ar.pricing'
import { Route as ArBusinessRouteImport } from './app/ar.business'
import { Route as LocaleSplatRouteImport } from './app/$locale.$'
import { Route as PreviewLegalPagesIdRouteImport } from './app/preview.legal-pages.$id'
import { Route as PreviewArticlesIdRouteImport } from './app/preview.articles.$id'
import { Route as PayloadAdminIndexRouteImport } from './app/_payload/admin.index'
import { Route as PayloadAdminSplatRouteImport } from './app/_payload/admin.$'

const ZakatCalculatorRoute = ZakatCalculatorRouteImport.update({
            id: '/zakat-calculator',path: '/zakat-calculator',getParentRoute: () => rootRouteImport
          })
const TermsConditionsRoute = TermsConditionsRouteImport.update({
            id: '/terms-conditions',path: '/terms-conditions',getParentRoute: () => rootRouteImport
          })
const StablecoinRoute = StablecoinRouteImport.update({
            id: '/stablecoin',path: '/stablecoin',getParentRoute: () => rootRouteImport
          })
const SendMoneyHomeRoute = SendMoneyHomeRouteImport.update({
            id: '/send-money-home',path: '/send-money-home',getParentRoute: () => rootRouteImport
          })
const RewardsRoute = RewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PerksRoute = PerksRouteImport.update({
            id: '/perks',path: '/perks',getParentRoute: () => rootRouteImport
          })
const PartnershipsRoute = PartnershipsRouteImport.update({
            id: '/partnerships',path: '/partnerships',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const InvestRoute = InvestRouteImport.update({
            id: '/invest',path: '/invest',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const HealthInsuranceRoute = HealthInsuranceRouteImport.update({
            id: '/health-insurance',path: '/health-insurance',getParentRoute: () => rootRouteImport
          })
const GetTheAppRoute = GetTheAppRouteImport.update({
            id: '/get-the-app',path: '/get-the-app',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CardsRoute = CardsRouteImport.update({
            id: '/cards',path: '/cards',getParentRoute: () => rootRouteImport
          })
const BusinessRoute = BusinessRouteImport.update({
            id: '/business',path: '/business',getParentRoute: () => rootRouteImport
          })
const AppStoreRedirectRoute = AppStoreRedirectRouteImport.update({
            id: '/app-store-redirect',path: '/app-store-redirect',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const PayloadRoute = PayloadRouteImport.update({
            id: '/_payload',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./app/_payload.lazy').then((d) => d.Route))
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ArIndexRoute = ArIndexRouteImport.update({
            id: '/ar/',path: '/ar/',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/$locale/',path: '/$locale/',getParentRoute: () => rootRouteImport
          })
const TermsCookieRoute = TermsCookieRouteImport.update({
            id: '/terms/cookie',path: '/terms/cookie',getParentRoute: () => rootRouteImport
          })
const TermsSplatRoute = TermsSplatRouteImport.update({
            id: '/terms/$',path: '/terms/$',getParentRoute: () => rootRouteImport
          })
const SyriaSlugRoute = SyriaSlugRouteImport.update({
            id: '/syria/$slug',path: '/syria/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsBusinessSuccessRoute = ProductsBusinessSuccessRouteImport.update({
            id: '/products/business-success',path: '/products/business-success',getParentRoute: () => rootRouteImport
          })
const PakistanSlugRoute = PakistanSlugRouteImport.update({
            id: '/pakistan/$slug',path: '/pakistan/$slug',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/news_/$slug',path: '/news/$slug',getParentRoute: () => rootRouteImport
          })
const HelpSlugRoute = HelpSlugRouteImport.update({
            id: '/help_/$slug',path: '/help/$slug',getParentRoute: () => rootRouteImport
          })
const CalculatorPairRoute = CalculatorPairRouteImport.update({
            id: '/calculator/$pair',path: '/calculator/$pair',getParentRoute: () => rootRouteImport
          })
const BusinessWaitlistRoute = BusinessWaitlistRouteImport.update({
            id: '/business_/waitlist',path: '/business/waitlist',getParentRoute: () => rootRouteImport
          })
const BangladeshSlugRoute = BangladeshSlugRouteImport.update({
            id: '/bangladesh/$slug',path: '/bangladesh/$slug',getParentRoute: () => rootRouteImport
          })
const ArticleSlugRoute = ArticleSlugRouteImport.update({
            id: '/article/$slug',path: '/article/$slug',getParentRoute: () => rootRouteImport
          })
const ArPricingRoute = ArPricingRouteImport.update({
            id: '/ar/pricing',path: '/ar/pricing',getParentRoute: () => rootRouteImport
          })
const ArBusinessRoute = ArBusinessRouteImport.update({
            id: '/ar/business',path: '/ar/business',getParentRoute: () => rootRouteImport
          })
const LocaleSplatRoute = LocaleSplatRouteImport.update({
            id: '/$locale/$',path: '/$locale/$',getParentRoute: () => rootRouteImport
          })
const PreviewLegalPagesIdRoute = PreviewLegalPagesIdRouteImport.update({
            id: '/preview/legal-pages/$id',path: '/preview/legal-pages/$id',getParentRoute: () => rootRouteImport
          })
const PreviewArticlesIdRoute = PreviewArticlesIdRouteImport.update({
            id: '/preview/articles/$id',path: '/preview/articles/$id',getParentRoute: () => rootRouteImport
          })
const PayloadAdminIndexRoute = PayloadAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => PayloadRoute
          }).lazy(() => import('./app/_payload/admin.index.lazy').then((d) => d.Route))
const PayloadAdminSplatRoute = PayloadAdminSplatRouteImport.update({
            id: '/admin/$',path: '/admin/$',getParentRoute: () => PayloadRoute
          }).lazy(() => import('./app/_payload/admin.$.lazy').then((d) => d.Route))





const PayloadRouteChildren = {
  PayloadAdminSplatRoute: PayloadAdminSplatRoute,PayloadAdminIndexRoute: PayloadAdminIndexRoute
}

const PayloadRouteWithChildren = PayloadRoute._addFileChildren(PayloadRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,PayloadRoute: PayloadRouteWithChildren,AboutRoute: AboutRoute,AppRoute: AppRoute,AppStoreRedirectRoute: AppStoreRedirectRoute,BusinessRoute: BusinessRoute,CardsRoute: CardsRoute,CareersRoute: CareersRoute,CompareRoute: CompareRoute,GetTheAppRoute: GetTheAppRoute,HealthInsuranceRoute: HealthInsuranceRoute,HelpRoute: HelpRoute,InvestRoute: InvestRoute,NewsRoute: NewsRoute,PartnershipsRoute: PartnershipsRoute,PerksRoute: PerksRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RewardsRoute: RewardsRoute,SendMoneyHomeRoute: SendMoneyHomeRoute,StablecoinRoute: StablecoinRoute,TermsConditionsRoute: TermsConditionsRoute,ZakatCalculatorRoute: ZakatCalculatorRoute,LocaleSplatRoute: LocaleSplatRoute,ArBusinessRoute: ArBusinessRoute,ArPricingRoute: ArPricingRoute,ArticleSlugRoute: ArticleSlugRoute,BangladeshSlugRoute: BangladeshSlugRoute,BusinessWaitlistRoute: BusinessWaitlistRoute,CalculatorPairRoute: CalculatorPairRoute,HelpSlugRoute: HelpSlugRoute,NewsSlugRoute: NewsSlugRoute,PakistanSlugRoute: PakistanSlugRoute,ProductsBusinessSuccessRoute: ProductsBusinessSuccessRoute,SyriaSlugRoute: SyriaSlugRoute,TermsSplatRoute: TermsSplatRoute,TermsCookieRoute: TermsCookieRoute,LocaleIndexRoute: LocaleIndexRoute,ArIndexRoute: ArIndexRoute,PreviewArticlesIdRoute: PreviewArticlesIdRoute,PreviewLegalPagesIdRoute: PreviewLegalPagesIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)